module.exports = __webpack_public_path__ + "c63774eac27dc9fe493268a73c09ad62.png";